import React, { memo } from 'react';

import styles from './Filter.module.less';

export default memo(({ classes, code, setCode, childCode, setChildCode, fold, setFold }) => {
  return (
    <div className={styles.Filter}>
      {classes.length > 1 && (
        <div>
          <label>类型：</label>
          <ul>
            {classes.map(cls => (
              <li
                key={cls.code}
                className={cls.code === code ? 'active' : ''}
                onClick={() => {
                  if (code === cls.code) return;

                  setCode(cls.code);
                }}
              >
                {cls.name}
              </li>
            ))}
          </ul>
        </div>
      )}
      {/*<div className={fold ? 'fold' : ''}>*/}
      <div className={''}>
        <label>分类：</label>
        <ul>
          {classes
            .find(cls => cls.code === code)
            .childClassList.map(cls => (
              <li
                key={cls.childCode}
                className={cls.childCode === childCode ? 'active' : ''}
                onClick={() => {
                  if (childCode === cls.childCode) return;
                  
                  setChildCode(cls.childCode);
                }}
              >
                {cls.childName}
              </li>
            ))}
        </ul>
        {/* <span
          onClick={() => {
            setFold(!fold);
          }}
        >
          {fold ? '更多' : '收起'}
          <i></i>
        </span> */}
      </div>
    </div>
  );
});
